import styled from 'styled-components';

export const AdventCalendarContainer = styled.div`
  color: ${(props) => props.textColor};
  max-width: ${(props) => props.maxWidth};
`;

export const DoorDialog = styled.div`
  display: ${(props) => (props.dialogShown ? 'block' : 'none')};
`;

export const DoorDialogStep = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')}
`;

export const DoorImageWrapper = styled.div.attrs((props) => ({
  style: {
    top: `${props.top}%`,
    left: `${props.left}%`,
    maxWidth: `${props.doorSize}px`,
  },
}))`
  ${(props) => props.isMobile && `
    transform: translate(-50%,-50%);
  `}
`;

export const DoorImage = styled.img`
  max-width: ${(props) => props.doorSize}px;
`;

export const DoorText = styled.div`
  color: ${(props) => props.textColor};
  font-size: ${(props) => props.textSize}px;
`;

export const FooterColumn = styled.div`
  width: 33%;
  float: left;
  min-height: 1px;
`;
